"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useEntityRoute = void 0;
var use_entity_definition_named_1 = require("./use-entity-definition-named");
var useEntityRoute = function (name, route) {
  var entityConfig = (0, use_entity_definition_named_1.useEntityDefinitionNamed)(name);
  var entityRoute = entityConfig.routes && entityConfig.routes[route];
  if (!entityRoute) {
    throw new Error("Route '".concat(route, "' is missing for Entity '").concat(name, "'"));
  }
  return entityRoute;
};
exports.useEntityRoute = useEntityRoute;